/* USER STATUS ENUM */

// Server values
const ACTIVE = 'ACTIVE';
const INACTIVE = 'INACTIVE';
const PENDING = 'PENDING';

// Map server values to user friendly labels
const label: { [key: string]: string } = {};
label[ACTIVE] = 'Active';
label[INACTIVE] = 'Inactive';
label[PENDING] = 'Pending';

export default { ACTIVE, INACTIVE, PENDING, label };
